var CurrencyType = /* @__PURE__ */ ((CurrencyType2) => {
  CurrencyType2["USD"] = "USD";
  CurrencyType2["CarbonOffsetTons"] = "CARBON_OFFSET_TONS";
  CurrencyType2["Beers"] = "BEERS";
  CurrencyType2["IceCream"] = "PINTS_OF_ICE_CREAM";
  return CurrencyType2;
})(CurrencyType || {});

export { CurrencyType };
//# sourceMappingURL=CurrencyType.esm.js.map
